module.exports = __webpack_public_path__ + "img/ERS.4afca32d.svg";